import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { BankAccountResource } from "@exonn/js-sdk";

export const module: ModuleOptions<BankAccountResource> = {
  resource: ResourceEnum.BankAccount,
  bigIcon: <i className="icon-20-bank" />,
  smallIcon: <i className="icon-15-bank" />,

  tabs: {
    edit: {
      titleProp: "name",
    },
  },
};
